import { ItsOnClient } from '@bestdoctor/its-on-client';

export const itsOnClient = new ItsOnClient({
  url: String(process.env.REACT_APP_ITS_ON_URL),
});

export const isActive = (flag: string) => itsOnClient.isActive(flag);
